module.exports = __webpack_public_path__ + "img/suleeporn.3e24da47.jpg";